import { Box, Spinner, Text } from "grommet";
import { useTranslation } from "react-i18next";
import { AUTH_STATUSES } from "../../slices/authSlice";
import { useAuth } from "../../auth";
import { TwitchAuth } from "./TwitchAuth";

export const AuthenticatedRoute = ({ children }) => {
    const { status } = useAuth();

    switch (status) {
        case AUTH_STATUSES.AUTHENTICATED:
            return children;
        case AUTH_STATUSES.ANONYMOUS:
        case AUTH_STATUSES.ERROR:
            return <TwitchAuth />;
        case AUTH_STATUSES.CHECKING:
        case AUTH_STATUSES.REDIRECTING:
        default:
            return <AuthLoading />;
    }
};

const AuthLoading = () => {
    const { t } = useTranslation('common');

    return (
        <Box align="center" gap="small" pad="large" role="status" aria-live="polite">
            <Spinner />
            <Text>{t('authChecking')}</Text>
        </Box>
    );
};
